import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

/**
 * Hook to reload the application after 24 hours of continuous use.
 * Reloads the application after 24 hours on navigation change to ensure the latest version is used.
 */
export function useTimeBasedReload() {
    const location = useLocation();
    const initialTimestamp = useRef(Date.now());

    useEffect(() => {
        // Check if 24 hours have passed since the initial timestamp
        const now = Date.now();

        if (now - initialTimestamp.current > TWENTY_FOUR_HOURS_MS) {
            // Reload the application if 24 hours have passed
            window.location.reload();
        }
    }, [location]); // This effect runs on every navigation change
}
